import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GSPMetadataService } from '@gsp-lcm/metadata-selector';
import { InternalCommonEntityService } from '../service/internal-common-entity-service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-ce-treeclassifier',
  templateUrl: './treeclassifier.component.html',
  styleUrls: ['./treeclassifier.component.css']
})

export class TreeclassifierComponent implements OnInit {
  @Input() metadataPath: string;
  @Input() onlyDisplayCurrentProject: boolean;
  files: any;
  @Output() selectedChange = new EventEmitter<string>();
  classifier: any[] = [
    { id: 'default', text: 'å½åå·¥ç¨' }
  ];

  constructor(private iceService: InternalCommonEntityService, private gspMetadataService: GSPMetadataService) { }

  ngOnInit() {
    //å±ç¤ºå½åå·¥ç¨
    if (this.onlyDisplayCurrentProject === true) {
      this.files = this.classifier;
      this.iceService.GetMetadataProjPath(this.metadataPath).subscribe(proj => {
        this.iceService.currentProjectPath = proj.projectPath;
      });
      this.selectedChange.emit(this.files[0]); // é»è®¤æ¬å·¥ç¨ä¸ç
    }
    //å±ç¤ºææå·¥ç¨ 
    else {
      // è·åæ èç¹mockæ°æ®
      this.files = this.iceService.getMetadataClassifier();
      this.files[1].items = [];
      this.files[2].items = [];
      let packages = [];
      // è·åå·¥ç¨è·¯å¾
      this.iceService.GetMetadataProjPath(this.metadataPath).subscribe(proj => {
        this.iceService.currentProjectPath = proj.projectPath;
        this.iceService.GetMetadataProjectInfo().subscribe(meta => {
          packages = meta.nugetPackageRefs;
          let index = 0;
          packages.forEach(item => {
            const child = {
              id: item.name,
              text: item.name + '.nupkg',
              items: []
            };
            if (this.files) {
              this.files[1].items.push(child);
            }
            this.gspMetadataService.GetDevRootPath().subscribe(root => {
              const rootPath = root + this.iceService.packRefPath;
              this.gspMetadataService.GetMetadataPackagesUnderNugetDir(rootPath + '/' + item.name).subscribe(pkgs => {
                if (pkgs) {
                  let mdpkg;
                  pkgs.forEach(pkg => {
                    mdpkg = {
                      id: pkg.header.name,
                      text: pkg.header.name,
                      desc: pkg.header.location
                    };
                    child.items.push(mdpkg);
                  });
                  // this.files[1].items[index].push(mdpkg);
                }
                index = index + 1;
              });
            });
          });
          this.selectedChange.emit(this.files[0]); // é»è®¤æ¬å·¥ç¨ä¸ç
        });
      });
      // æ·»å æ¬å°å
      this.gspMetadataService.GetDevRootPath().subscribe(root => {
        const rootPath = root + this.iceService.packRefPath;
        this.gspMetadataService.GetLocalPackages(rootPath).subscribe(pkgs => {
          if (pkgs) {
            let mdpkg;
            pkgs.forEach(pkg => {
              mdpkg = {
                id: pkg.header.name,
                text: pkg.header.name,
                desc: pkg.header.location
              };
              this.files[2].items.push(mdpkg);
            });
            // this.files[1].items[index].push(mdpkg);
          }
        });
      });
    }
  }

  // æ èç¹ç¹å»åäºä»¶
  nodeSelect(event) {
    // if (!event.dataItem.id.endsWith('.mdpkg')) {
    this.selectedChange.emit(event.dataItem);
    const treenode = {
      'PackageName': event.dataItem.id,
      'Location': event.dataItem.desc,
      'MetadataInfo': []
    };
    this.iceService.addMetadata({
      treenode
    });
    // }
  }
}
